/* eslint-disable no-debugger */
var _module = require('../../components/module.js');
var _ = require('lodash');


require('../babou');


_module.factory('Search', [
    '$log',
    '$http',
    '$babou',
    function SearchFactory($log, $http,$babou) {
        function Search(searchTerm) {
            this.search_term = searchTerm;
        }
        /**
         * Returns a paginated list of results
         *
         * @function getListings
         * @param {Object} [options={}]
         * @param {int} [options.page=1]
         * @param {int} [options.limit=50]
         */
        Search.prototype.getListings = function getListings(options) {
            var defOptions = {
                page: 1,
                limit: 50
            };
            var opt = _.merge(defOptions, options);
            opt.skip = (opt.page - 1) * opt.limit;
            opt.include_listings = true;
            opt.include_listing_stats = false;
            opt.useSourceZipBlacklist = true;
            opt.orderBy = opt.orderby;
            opt.orderby = undefined;
            if(!opt.bypasscache) delete opt.bypasscache;

            var result = $http({
                method: 'GET',
                url:'/v1/search/area',
                params: {searchTerm: this.search_term}
            })
            .then(function onSuccessArea(res){
                var areas = [res.data.data];
                return $babou.searchListings(areas,opt);
            });

            return result.then(function onSuccess(response) {
                var listings = [];
                response.data.page.listings.forEach(function(listing){
                    $babou.formatListingFields(listing,listings);
                });
                response.data.page.listings = listings;
                return response.data.page;
            }).catch(function onError(err){
                $log.error(err);
                return [];
            });
        };
        // Return our class
        return Search;
    }
]);

















// var listingsFilters = require('./listings-filters');

// require('../transform');

/**
 * DEPRECATED
 * 2017-04-25 - Leland Cope
 */

_module.service('$search', [
    '$log',
    '$q',
    '$http',
    '$transform',

    function searchService($log, $q, $http, $transform) {
        return function searchFunc(q) {
            $log.warn('WARNING: $search is deprecated. Everything should be done through a search filter and server side pagination');

            return $q.when({
                results: [],
                result_map: []
            });


            // return $http.get('/v1/search', { params: { q: q } })
            // .then(function searchResponse(response) {
            //     var data = response.data.data;
            //     var resultMapings = data.result_map;
            //     var results = data.results;

            //     data._results = results;
            //     data.results = $transform.zip(resultMapings, results).filter(function filterResults(listing) {
            //         return listing.active && !(~['Rental'].indexOf(listing.type) || ~['Rent'].indexOf(listing.listing_category));
            //     });

            //     if(data.direct_match) {
            //         data.results.push(data.direct_match);
            //     } else {
            //         var fakeScores = [];

            //         data.results = _filterResults(data.results);

            //         data.results.forEach(function (obj) {
            //             if(obj.fake_scores) fakeScores.push(obj);
            //         });

            //         $log.log('============================================');
            //         $log.log('Total In Search', data.results.length);
            //         $log.log('Total Fake Scores', fakeScores.length);
            //         $log.log('Total Real Scores', data.results.length - fakeScores.length);
            //         $log.log('Fake Scored Objects', fakeScores);
            //         $log.log('============================================');
            //     }

            //     return data;
            // });
        };
    }
]);


/*
@function _filterResults
@param {Array} listings
@returns {Array}
*/
// function _filterResults(listings) {
//     var filterFunctions = [
//         listingsFilters.removeInactiveListings,
//         listingsFilters.filterFirstAMNoHeorImage
//     ];

//     return filterFunctions.reduce(function (listings, filterFunc) {
//         return filterFunc(listings);
//     }, listings);
// }
